import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ProductList from "./Pages/ProductList/ProductList";
import { Link, BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProductListWithoutCache from "./Components/ProductListWithoutCache/ProductListWithoutCache";

const queryClient = new QueryClient();
const App = () => {
  return (
    // Provide the client to your App
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className='flex h-screen flex-col'>
          <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
            <div className='container-fluid'>
              <button
                className='navbar-toggler'
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#navbarText'
                aria-controls='navbarText'
                aria-expanded='false'
                aria-label='Toggle navigation'
              >
                <span className='navbar-toggler-icon'></span>
              </button>
              <div className=' navbar-collapse' id='navbarText'>
                <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
                  <li className='nav-item'>
                    <Link
                      to='/product-with-cache'
                      className='nav-link text-white'
                    >
                      Product With Cache
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      to='/product-without-cache'
                      className='nav-link text-white'
                    >
                      Product Without Cache
                    </Link>
                  </li>
                </ul>
                <span className='navbar-text'>
                  <button
                    className='btn btn-sm btn-outline-secondary'
                    type='button'
                  >
                    Login
                  </button>
                </span>
              </div>
            </div>
          </nav>

          <Switch>
            <Route path='/product-with-cache'>
              <ProductList />
            </Route>
            <Route path='/product-without-cache'>
              <ProductListWithoutCache />
            </Route>
            <Route path='/'>
              <p className='h1 d-flex justify-content-center h-full items-center'>
                Caching high volume websites
              </p>
            </Route>
          </Switch>
        </div>
      </Router>
    </QueryClientProvider>
  );
};
const DemoPage = () => {
  return (
    <div className='App'>
      <header className='App-header'>
        <ProductList></ProductList>
      </header>
    </div>
  );
};

export default App;
